/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { ConfirmationModal, SuccessModal } from '../index';
import { useState } from 'react';
import { apiUrl } from '../../utilities/apiUrl';
import { LockOutlined } from '@mui/icons-material/';
import { Box, Typography } from '@mui/material';

export const LockEmpModal = (props) => {
  const [lockSuccessOpen, setLockSuccessOpen] = useState(false);

  // LOCK EMPLOYEE RECORD HANDLER
  const handleLock = () => {
    fetch(apiUrl('/employee/lock/' + props.selectedEmp), {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setLockSuccessOpen(true);
        } else {
          alert(data.message);
        }
      });
  };
  return (
    <>
      <ConfirmationModal
        open={props.open}
        onClose={props.onClose}
        primaryClickHandler={() => {
          handleLock();
          props.onClose();
        }}
        secondaryClickHandler={props.onClose}
        title={
          <Box display="flex" alignItems="center" gap={1}>
            <LockOutlined sx={{ fontSize: 30, color: '#f0ad4e' }} />
            <Typography variant="h6" fontWeight={600} color="warning.main">
              Lock Employee
            </Typography>
          </Box>
        }
        desc={
          <Box>
            <Typography variant="body1" sx={{ mt: 3, mb: 2 }}>
              Are you sure you want to lock:
            </Typography>
            <Typography
              variant="h6"
              fontWeight={700}
              color="warning.main"
              sx={{ mb: 5 }}
            >
              {props.lockName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              This will remove the employee’s access to the EPS.
            </Typography>
          </Box>
        }
        primaryBtnName={'Lock'}
        secondaryBtnName={'Cancel'}
        primaryStyle={{
          bgcolor: '#f0ad4e',
          border: '1px solid #f0ad4e',
          '&:hover': {
            bgcolor: '#ec971f !important',
            borderColor: '#ec971f',
          },
        }}
      />
      <SuccessModal
        open={lockSuccessOpen}
        onClose={() => {
          setLockSuccessOpen(false);
          props.resetIndex();
          window.location.reload();
        }}
        close={() => {
          setLockSuccessOpen(false);
          props.resetIndex();
          window.location.reload();
        }}
        desc={'You have successfully locked an employee.'}
      />
    </>
  );
};
